$(document).ready(function() {
  $('.plus_minus_quantity').click(function() {
    var data_type = $(this).data('type');
    var stock_id  = $(this).data('stock-id');

    if (data_type == "plus") {
      $(`#label-update-qty-${stock_id}`).text(I18n.t('actions.plus_quantity'));
      $(`#plus-qty-${stock_id}`).prop('disabled', false);
      $(`#minus-qty-${stock_id}`).prop('disabled', true);
      $(`#input-plus-${stock_id}`).removeClass('hide');
      $(`#input-minus-${stock_id}`).addClass('hide');
      $('#pending-orders').addClass('hide');
    } else {
      $(`#label-update-qty-${stock_id}`).text(I18n.t('actions.minus_quantity'));
      $(`#plus-qty-${stock_id}`).prop('disabled', true);
      $(`#minus-qty-${stock_id}`).prop('disabled', false);
      $(`#input-plus-${stock_id}`).addClass('hide');
      $(`#input-minus-${stock_id}`).removeClass('hide');
      $('#pending-orders').removeClass('hide');
    }

    $('.plus-qty-cls').keyup(function(){
      var qty = $(`#plus-qty-${stock_id}`).val();
      $(`#update-qty-text-${stock_id}`).text(`+${qty}`);
    });

    $('.minus-qty-cls').keyup(function(){
      var qty = $(`#minus-qty-${stock_id}`).val();
      $(`#update-qty-text-${stock_id}`).text(`-${qty}`);
    });

    if (data_type == "minus") {
      reloadPendingOrdersCount(stock_id);

      setInterval(function(){
        if ($(`#exampleModal-${stock_id}`).hasClass('show')) {
          reloadPendingOrdersCount(stock_id);
        }
      }, 20000);
    }

    $(`#submit-plus-minus-qty-${stock_id}`).click(function(){
      $(`#error-plus-qty`).remove();
      $(`#error-minus-qty`).remove();

      if (data_type == "plus") {
        var min_qty  = parseInt($(`#plus-qty-${stock_id}`).attr('min'));
        var quantity = parseInt($(`#plus-qty-${stock_id}`).val());

        if (quantity < min_qty) {
          $(`#plus-qty-${stock_id}`).after(`<small id="error-plus-qty" style="color: red;">` + I18n.t('global.alerts.plus_quantity_must_be_more_than') + ` ${min_qty}</small>`);
        } else {
          $(`#exampleModal-${stock_id}`).modal('hide');
        }
      } else {
        var min_qty  = parseInt($(`#minus-qty-${stock_id}`).attr('min'));
        var max_qty  = parseInt($(`#minus-qty-${stock_id}`).attr('max'));
        var quantity = parseInt($(`#minus-qty-${stock_id}`).val());

        if (quantity < min_qty) {
          $(`#minus-qty-${stock_id}`).after(`<small id="error-minus-qty" style="color: red;">` + I18n.t('global.alerts.minus_quantity_must_be_more_than') + ` ${min_qty}</small>`);
        } else if (quantity > max_qty) {
          $(`#minus-qty-${stock_id}`).after(`<small id="error-minus-qty" style="color: red;">` + I18n.t('global.alerts.minus_quantity_must_be_less_than_or_equal') + ` ${max_qty}</small>`);
        } else {
          $(`#exampleModal-${stock_id}`).modal('hide');
        }
      }
    });

  })

  function reloadPendingOrdersCount(stock_id) {
    $('#reload-pending-count').removeClass('hide');
    console.log("test")

    // Reload pending orders count
    setTimeout(() => {
      $.ajax({
        type: "GET",
        dataType:"json",
        data: {'stock_id' : stock_id},
        url: "/api/services/reload_pending_orders_count",
        success: function(response){
          $(`#pending-order-${stock_id}`).text(response.total_pending);
          $('#reload-pending-count').addClass('hide');
          $(`#minus-qty-${stock_id}`).attr('max', response.max_reduce_qty);
        }
      });
    }, 50);
  }
});